import type { FlightRoute } from 'common/packageCache';
import moment from 'moment';

function renderOperatingFromCell(text: string, record: FlightRoute): string {
  return record.operatingFrom ? moment(record.operatingFrom).format('YYYY-MM-DD') : '';
}

export default renderOperatingFromCell;
